import axios from "axios";
import Logger from "js-logger";

class VermittlerNummerService {
  http() {
    const headers = {
      "Content-Type": "application/json",
    };

    return axios.create({
      baseURL: process.env.VUE_APP_BACKEND_URL,
      headers: headers,
    });
  }

  getBaseUrl() {
    return "/api/makler-tarifrechner/";
  }

  ladeVermittlernummerFuerMaklerLink(vermittlerId: string) {
    Logger.debug("ladeVermittlernummerFuerMaklerLink", vermittlerId);
    return this.http()
      .get(this.getBaseUrl() + "vermittlerNummer/" + vermittlerId)
      .then((value) => {
        return value;
      });
  }
}

export default new VermittlerNummerService();
